import React from "react";
import PropTypes from "prop-types";

export class RefreshAtEnd extends React.Component {
  static propTypes = {
    root: PropTypes.string.isRequired, // list container
    onVisible: PropTypes.func, // callback to call when loading is visible
    children: PropTypes.node // to load loading animation
  };

  static defaultProps = {
    onVisible: () => {}
  };

  constructor(props) {
    super(props);
    this.lastRef = React.createRef();
  }

  componentDidMount() {
    this.rootElem =
      document.querySelector(`${this.props.root} .ScrollbarsCustom-Scroller`) ||
      document.querySelector(`${this.props.root}`);
    if (!this.lastRef.current) return;
    this.observer = new IntersectionObserver(
      this.interSectionCallback.bind(this),
      {
        threshold: [0.5]
      }
    );
    this.observer.observe(this.lastRef.current);
  }

  interSectionCallback(entries, observer) {
    entries.forEach((entry) => {
      if (
        entry.intersectionRatio >= 0.5 &&
        this.rootElem.scrollHeight - this.rootElem.offsetHeight > 0
      ) {
        this.props.onVisible();
      }
    });
  }

  render() {
    let { root, children, onVisible, ...restProps } = this.props;
    return (
      <div ref={this.lastRef} className="animation" {...restProps}>
        {this.props.children ? this.props.children : "Loading..."}
      </div>
    );
  }
}
